import { Component, Input, ViewEncapsulation, OnInit, Injector, Inject, PLATFORM_ID, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import { Module, TextPosition } from '../../model/ModuleModel';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MainTitle } from '../main-title/main-title.component';
import { MediaPictureService } from '../../services/media-picture.service';
import { IframeEmbedModel } from './iframe-embed.model';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'iframe-embed',
  template: `
    <div class="iframe-embed-container {{textPosition?.toLocaleLowerCase()}}">
      <div *ngIf="this.module.title || this.module.pretitle || this.module.subtitle || this.module.more_text" class="main-title -justify-{{module.text_vertical_align?.toLocaleLowerCase()}}" [ngClass]="{'eva-3-card': textPosition === 'CARD'}">
        <img *ngIf="module.logo && mediaPictureService.getMediaUrl(module.logo.src) as src"   class="logo" [src]="src" loading="lazy" alt="logo"/>
        <main-title [data]="mainTitleData" [moduleId]="this.getModuleId()" [uniqueId]="module.unique_id"  titleColor="#888" preTitleColor="#888" subtitleColor="#888" textColor="#888"></main-title>
      </div>
      <iframe #iframe [src]="iframeUrl" frameborder="0" class="iframe" [ngStyle]="dynamicIframeStyles()" scrolling="auto" title="embedded"></iframe>
    </div>
  `,
  styleUrls: ['./iframe-embed.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IframeEmbedComponent extends AbstractComponent implements OnInit, AfterViewInit {
  @ViewChild('iframe') iframeHTMLElement: ElementRef;
  @Input() moduleId: string;
  @Input() override module: Module<IframeEmbedModel>
  @Input() device: { type: string };

  iframeUrl: SafeResourceUrl;

  textPosition?: TextPosition;
  mainTitleData: MainTitle;

  constructor(injector: Injector, private sanitizer: DomSanitizer, public mediaPictureService: MediaPictureService,
    @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
  }

  ngOnInit(): void {
    this.textPosition = this.module.text_position
    if (this.module.data.iframe) {
      if (isPlatformBrowser(this.platformId)) {
        this.addUTMQueryParams();
      }
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.module.data.iframe)
    }
    if (this.module.data['size'] === undefined) {
      this.module.data.size = {
        width: '800',
        height: '600'
      };
    }
    this.mainTitleData = {
      title: this.module.title,
      pre_title: this.module.pretitle,
      sub_title: this.module.subtitle,
      more_text: this.module.more_text,
      tip_message: this.module.tip_message
    }
  }

  ngAfterViewInit(): void {
    if (this.module.data.allow) {
      this.iframeHTMLElement.nativeElement.setAttribute('allow', this.module.data.allow);
    }
  }

  getModuleId(): string {
    return this.moduleId;
  }

  dynamicIframeStyles() {
    return this.device.type === 'MOBILE' ? { 'min-height.px': this.module.data.size?.height } : { 'max-width.px': this.module.data.size?.width, 'min-height.px': this.module.data.size?.height }
  }

  private addUTMQueryParams(): void {
    const utmQueryParamKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "mktdata"];
    const currentUrlQueryParams = new URLSearchParams(window.location.search);
    const iframeUrl = new URL(this.module.data.iframe!);

    utmQueryParamKeys.forEach(utmParamKey => {
      const utmParamValue = currentUrlQueryParams.get(utmParamKey);
      utmParamValue && iframeUrl.searchParams.append(utmParamKey, utmParamValue);
    })

    this.module.data.iframe = iframeUrl.href;
  }
}
